const twoHoursInMilliseconds = 2 * 60 * 60 * 1000;
const threeHoursInMilliseconds = 3 * 60 * 60 * 1000; 
const threeMinutesInMilliseconds = 3 * 60 * 1000; 


const SessionConfiguration = Object.freeze({
    SESSION_LIMIT : threeHoursInMilliseconds
});

export default SessionConfiguration;